const BASE = process.env.REACT_APP_API_URL_DEFAULT;

const ENDPOINT_MAP = {
  ADN: {
    Queue: `${BASE}adn/ResourceManagerQueue`,
    QueueFilters: `${BASE}adn/ResourceManagerQueue/filters`,
    OrderDetail: `${BASE}adn/OrderDetail`,
    AssignEngagementManager: `${BASE}adn/OrderRequestAction/assign-engagement-manager`,
    ExportExcel: `${BASE}adn/ExcelExport/resource-manager-queue`,
  },
  AOA: {
    Queue: `${BASE}aoa/AOAResourceManagerQueue`,
    QueueFilters: `${BASE}aoa/AOAResourceManagerQueue/filters`,
    OrderDetail: `${BASE}aoa/AOAOrderDetail`,
    AssignEngagementManager: `${BASE}aoa/AOAOrderRequestAction/assign-engagement-manager`,
    ExportExcel: `${BASE}aoa/AOAExcelExport/resource-manager-queue`,
  },
};

export const getResourceManagerUrls = (domain = "ADN") =>
  ENDPOINT_MAP[domain] || ENDPOINT_MAP.ADN;
